const nameSpace = 'recipientPage.actions';

export default nameSpace;
